"use client";

import { useTranslations } from "next-intl";

export default function JoinCtaSection() {
  const t = useTranslations("JoinCta");

  return (
    <section className="mx-auto max-w-6xl px-4 py-12 sm:px-8 lg:px-10">
      <div className="flex flex-col items-center gap-6 rounded-3xl bg-[#FDE047] px-6 py-16 text-center sm:px-12 sm:py-20">
        <h2 className="text-balance text-4xl font-bold tracking-tight text-[#18181b] sm:text-5xl">
          {t("heading")}
        </h2>
        <p className="max-w-xl text-base text-[#3f3f46] sm:text-lg">
          {t("paragraph")}
        </p>
        <a
          href="#clanarine"
          className="mt-2 inline-block rounded-full bg-[#18181b] px-8 py-3 text-sm font-medium text-white transition-colors hover:bg-[#27272a]"
        >
          {t("cta")}
        </a>
      </div>
    </section>
  );
}
